<template>
  <v-container fluid fill-height class="ob-hero">
    <v-slide-y-transition mode="out-in">
      <v-layout align-center style="align-items: stretch" class="pt-0">
        <v-flex style="flex: 0 0 500px">
          <v-layout column fill-height>
            <v-flex xs12 class="mt-0 pt-0">
              <h1 class="primary--text display-2 mt-5 mb-4">
                <img src="/img/logo_big.png" alt="TUD's Analytics logo">
              </h1>
              <p class="primary--text title font-weight-light" style="text-align: center" v-html="translateUI('LandingHero_1', lang)">
              </p>
            </v-flex>
            <v-flex xs12>
              <v-card class="transparent elevation-0">
                <v-card-title class="title primary--text pa-0" style="justify-content: center" v-html="translateUI('LandingHero_2', lang)">
                </v-card-title>
                <v-card-text class="pa-0">
                  <v-scroll-x-transition group hide-on-leave>
                    <v-card v-if="slide === 1" :key="1" class="transparent elevation-0">
                      <v-card-text class="primary--text">
                        <v-layout align-center>
                          <v-flex xs3 class="ob-icon-size">
                            <i class="flaticon-graph secondary--text"></i>
                          </v-flex>
                          <v-flex xs9 class="" v-html="translateUI('LandingSlider_1', lang)">
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                    <v-card v-if="slide === 2" :key="2" class="transparent elevation-0">
                      <v-card-text class="primary--text">
                        <v-layout align-center>
                          <v-flex xs3 class="ob-icon-size">
                            <i class="flaticon-chart-1 secondary--text"></i>
                          </v-flex>
                          <v-flex xs9 class="" v-html="translateUI('LandingSlider_2', lang)">
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                    <v-card v-if="slide === 3" :key="3" class="transparent elevation-0">
                      <v-card-text class="primary--text">
                        <v-layout align-center>
                          <v-flex xs3 class="ob-icon-size">
                            <i class="flaticon-report secondary--text"></i>
                          </v-flex>
                          <v-flex xs9 class="" v-html="translateUI('LandingSlider_3', lang)">
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-scroll-x-transition>
                </v-card-text>
                <v-card-actions>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-progress-linear height="1" :value="progressValue" :color="progressColor"></v-progress-linear>
                    </v-flex>
                    <v-flex xs12 d-flex justify-center>
                      <v-spacer></v-spacer>
                      <v-btn v-for="i in 3" :key="i" flat icon small @click="slide = i" color="primary" class="ob-no-grow">
                        <v-icon small>{{ slide === i ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}</v-icon>
                      </v-btn>
                      <v-spacer></v-spacer>
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-flex>
            <v-flex xs12 align-content-center d-flex>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-btn color="accent" large @click="showComponent('login')">LOGIN</v-btn>
              <v-btn color="white" class="primary--text" large @click="showComponent('login')" style="display: none">INFO</v-btn>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex d-flex justify-center style="flex: 1 0 500px">
          <div style="flex: 0 0 500px !important">
            <v-scroll-x-transition group hide-on-leave>
              <ob-login v-if="show.login" @close-login="close('login')" @show-inregistrare="showComponent('inregistrare')" key="login"></ob-login>
              <ob-new-account v-if="show.inregistrare" key="inregistrare" @close-inregistrare="close('inregistrare')"></ob-new-account>
            </v-scroll-x-transition>
          </div>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
import InregistrareCont from '@/components/InregistrareCont';
import Login from '@/components/Login';
import translate from '@/mixins/Translate';

export default {
  name: 'home',
  mixins: [translate],
  components: {
    'ob-login': Login,
    'ob-new-account': InregistrareCont
  },
  data: () => ({
    slide: 1,
    timer: null,
    elapsed: 0,
    show: {
      login: false,
      info: false,
      inregistrare: false
    }
  }),
  computed: {
    progressValue () {
      return Math.ceil(this.elapsed * 100 / 6000)
    },
    progressColor () {
      return ['primary', 'warning', 'error'][Math.floor(this.progressValue / 40)]
    },
    dictionarUI () {
      return this.$store.getters['dictionar/ui']
    },
    lang () {
      return this.$store.getters['dictionar/lang']
    }
  },
  methods: {
    showComponent (type) {
      switch (type) {
        case 'login': {
          this.show.login = true
          this.show.info = false
          this.show.inregistrare = false
          break
        }
        case 'inregistrare': {
          this.show.login = false
          this.show.info = false
          this.show.inregistrare = true
          break
        }
        case 'info': {
          this.show.login = false
          this.show.info = true
          this.show.inregistrare = false
          break
        }
      }
    },
    close (type) {
      switch (type) {
        case 'login': {
          this.show.login = false
          break
        }
        case 'inregistrare': {
          this.show.inregistrare = false
          break
        }
        case 'info': {
          this.show.info = false
          break
        }
      }
    },
    nextSlide () {
      this.elapsed += 100
      if (this.elapsed >= 6000) {
        this.elapsed = 0
        this.slide++
        if (this.slide > 3) this.slide = 1
      }
    }
  },
  mounted () {
    this.timer = setInterval(() => (this.nextSlide()), 100)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>
